import type { SearchBoxItem } from '@/hooks/context/searchBox/contextConfig';

export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SELECT_MULTIPLE = 'SELECT_MULTIPLE';
export const UNSELECT_MULTIPLE = 'UNSELECT_MULTIPLE';
export const UNSELECT_ALL = 'UNSELECT_ALL';
export const UNSELECT_EXPECT_FIRST_ONE = 'UNSELECT_EXPECT_FIRST_ONE';
export const SELECT_ONLY_ONE = 'SELECT_ONLY_ONE';
export const SELECT_ALL = 'SELECT_ALL';
export const SET_FILTERED_DATA = 'SET_FILTERED_DATA';
export const SET_IS_DISABLED = 'SET_IS_DISABLED';
export const SET_INPUT_VALUE = 'SET_INPUT_VALUE';

export type SearchBoxReducerActionsType<TItem extends SearchBoxItem> =
    | {
          type: typeof ADD_ITEM | typeof REMOVE_ITEM | typeof SELECT_ONLY_ONE;
          payload: TItem;
      }
    | {
          type: typeof SET_FILTERED_DATA;
          payload: TItem[];
      }
    | { type: typeof UNSELECT_ALL | typeof SELECT_ALL | typeof UNSELECT_EXPECT_FIRST_ONE }
    | {
          type: typeof SELECT_MULTIPLE | typeof UNSELECT_MULTIPLE;
          payload: TItem['id'][];
      }
    | {
          type: typeof SET_IS_DISABLED;
          payload: boolean;
      }
    | {
          type: typeof SET_INPUT_VALUE;
          payload: string;
      };
